import { render, staticRenderFns } from "./FormFileUpload.vue?vue&type=template&id=4cbedeea&scoped=true"
import script from "./FormFileUpload.vue?vue&type=script&lang=js"
export * from "./FormFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbedeea",
  null
  
)

export default component.exports